/**
 * Rutas a los ficheros de `public/` (logotipos, imágenes de muestra).
 *
 * No se pueden escribir como `/logos/…` a secas: eso apunta a la raíz del
 * dominio, y la consola puede estar servida desde una subcarpeta
 * —`app.veniot.net/Nuevo/`— donde la raíz es de otra aplicación. Vite reescribe
 * las rutas del `index.html`, pero no las que están dentro del código, así que
 * hay que componerlas a mano con la base con la que se construyó.
 *
 * `BASE_URL` vale `/` cuando se sirve desde la raíz y `/Nuevo/` cuando no;
 * siempre termina en barra.
 */
export function rutaPublica(ruta: string): string {
  return `${import.meta.env.BASE_URL}${ruta.replace(/^\//, '')}`;
}

/**
 * Prefijo para las direcciones internas de la consola (`/alarmas`, `/camaras`).
 *
 * React Router lo necesita sin la barra final, y vacío cuando se sirve desde la
 * raíz: un `basename` de `/` provoca un aviso en consola.
 */
export const baseDeRutas = import.meta.env.BASE_URL.replace(/\/$/, '');
